import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPost } from '../services/api';

function PostDetail() {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPost();
  }, [postId]);

  const loadPost = async () => {
    setLoading(true);
    try {
      const data = await getPost(postId);
      setPost(data);
    } catch (err) {
      console.error('Failed to load post:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!post) {
    return <div className="alert alert-danger">Post not found.</div>;
  }

  return (
    <div>
      <Link to="/" className="btn btn-sm btn-outline-secondary mb-3">
        ← Back to Listings
      </Link>
      <div className="card">
        <div className="card-body">
          <h2 className="card-title">{post.title}</h2>
          <p className="text-muted">
            {post.animal_type.toUpperCase()} • {post.location || 'Unknown'}
          </p>
          <hr />
          <h5>Details</h5>
          <p className="card-text">{post.details || post.description || 'No details provided.'}</p>
          <hr />
          <h4 className="text-success">${post.price || '0'}</h4>
          <p className="text-muted">
            Posted: {new Date(post.created_at * 1000).toLocaleDateString()}
          </p>

          {post.images && post.images.length > 0 && (
            <>
              <hr />
              <h5>Photos</h5>
              <div className="hl-thumb-grid">
                {post.images.map((url, i) => (
                  <a key={i} href={url} target="_blank" rel="noreferrer">
                    <img src={url} alt={`${post.title} ${i + 1}`} className="hl-thumb" loading="lazy" />
                  </a>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PostDetail;
